import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AcademicFormRoutingModule } from './academic-form-routing.module';
import { AcademicLandingPageComponent } from './academic-landing-page/academic-landing-page.component';
import { AcademicStudentDetailsComponent } from './academic-student-details/academic-student-details.component';
import { AcademiclinkComponent } from './academiclink/academiclink.component';
import { AcademicHeadersComponent } from './academic-headers/academic-headers.component';
import { AcademicFootersComponent } from './academic-footers/academic-footers.component';
import { AcademicNodataFoundComponent } from './academic-nodata-found/academic-nodata-found.component';
import { AcademicStudentsTableComponent } from './academic-students-table/academic-students-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxSpinnerModule } from "ngx-spinner";
import {MatDatepickerModule} from '@angular/material/datepicker';
// import { MatNativeDateModule } from '@angular/material/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';




export const MY_DATE_FORMAT = {
  parse: {
   dateInput: 'LL',
 },
 display: {
   dateInput: 'DD MMMM YYYY',

 },
};


@NgModule({
  declarations: [
    AcademicLandingPageComponent,
    AcademicStudentDetailsComponent,
    AcademiclinkComponent,
    AcademicHeadersComponent,
    AcademicFootersComponent,
    AcademicNodataFoundComponent,
    AcademicStudentsTableComponent
  ],
  imports: [
    CommonModule,
    AcademicFormRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    AsyncPipe,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatDatepickerModule,
    MatNativeDateModule ,
  
    
  ],
  exports:[
    AcademicHeadersComponent,
    AcademicFootersComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }, ],
  
  
})
export class AcademicFormModule { }
